var OnlineStoresSettingsModel = /** @class */ (function () {
    function OnlineStoresSettingsModel(properties) {
        this.storeId = properties.storeId;
        this.locale = properties.locale;
        this.storeCurrency = properties.storeCurrency;
        this.layoutDirection = properties.layoutDirection;
        this.premiumFeatures = properties.premiumFeatures;
        this.price = properties.price;
        this.tax = properties.tax;
        this.shipping = properties.shipping;
    }
    OnlineStoresSettingsModel.fromGQL = function (_a, storeId) {
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var data = _a.data;
        var taxName = (_d = (_c = (_b = data.localeData) === null || _b === void 0 ? void 0 : _b.countries[0].properties) === null || _c === void 0 ? void 0 : _c.taxName) !== null && _d !== void 0 ? _d : '';
        var price = {
            showPriceRange: Boolean((_e = data.priceSettings) === null || _e === void 0 ? void 0 : _e.showPriceRange),
        };
        var tax = {
            localeTaxName: taxName,
            includeTaxOnProduct: Boolean((_f = data.priceSettings) === null || _f === void 0 ? void 0 : _f.taxOnProduct),
            showTaxDisclaimer: Boolean((_g = data.priceSettings) === null || _g === void 0 ? void 0 : _g.showTaxDisclaimer),
        };
        var shipping = {
            shippingDisclaimer: (_j = (_h = data.priceSettings) === null || _h === void 0 ? void 0 : _h.shippingDisclaimer) !== null && _j !== void 0 ? _j : null,
        };
        return new OnlineStoresSettingsModel({
            storeId: storeId,
            locale: data.clientConfig.language,
            storeCurrency: data.clientConfig.storeCurrency,
            layoutDirection: data.clientConfig.layoutDirection,
            premiumFeatures: data.premiumFeatures,
            price: price,
            tax: tax,
            shipping: shipping,
        });
    };
    return OnlineStoresSettingsModel;
}());
export { OnlineStoresSettingsModel };
//# sourceMappingURL=OnlineStoresSettingsModel.js.map